export interface ContactCard {
  id: string;
  icon: 'Briefcase' | 'Zap' | 'Code2' | 'Layers';
  title: string;
  body: string;
  colorVar: string;
  colorRgbVar: string;
}

/** Lien unique de prise de contact — commun aux deux langues. */
export const LINKEDIN_URL: string = 'https://www.linkedin.com/in/pierre-sere-asterion';

export const CONTACT_CARDS: readonly ContactCard[] = [
  {
    id:          'emploi',
    icon:        'Briefcase',
    title:       'Un emploi ?',
    body:        'Inspecteur, technicien qualité, intégrateur IA industriel — je suis ouvert à la bonne opportunité.',
    colorVar:    'var(--color-piloter)',
    colorRgbVar: 'var(--color-piloter-rgb)',
  },
  {
    id:          'defi',
    icon:        'Zap',
    title:       'Un défi à relever ?',
    body:        "Un problème que votre ERP ne règle pas, une inspection trop lente, une donnée qu'on ne lit jamais. Parlons-en.",
    colorVar:    'var(--color-temps)',
    colorRgbVar: 'var(--color-temps-rgb)',
  },
  {
    id:          'freelance',
    icon:        'Code2',
    title:       'Un contrat Freelance ?',
    body:        'Automatisation, app qualité sur mesure, déploiement IA industriel — je prends des mandats précis.',
    colorVar:    'var(--color-maitrise)',
    colorRgbVar: 'var(--color-maitrise-rgb)',
  },
  {
    id:          'asterion',
    icon:        'Layers',
    title:       'Asterion Solutions ?',
    body:        "Démo d'une application, partenariat, intégration sur mesure dans votre atelier — disponible pour en discuter.",
    colorVar:    'var(--color-anticiper)',
    colorRgbVar: 'var(--color-anticiper-rgb)',
  },
];

export const CONTACT_CTA: string = 'Écrire sur LinkedIn ↗';
export const CONTACT_PLACE: string = 'Québec, Canada';

/** PDF servi depuis public/ — commun aux deux langues (document en français). */
export const CV_URL: string = '/cv-pierre-sere.pdf';
export const CONTACT_CV_LABEL: string = 'Télécharger mon CV (PDF)';
